import $ from "jquery";

const BREAKPOINT_XS_MAX = 576;

$(function () {
  if ($(window).width() <= BREAKPOINT_XS_MAX) {
    $(document).on("click touchstart", '[data-js="jsMobileHover"]', function (e) {
        $('[data-js="jsMobileHover"]').removeClass("mobileActive");
        $(this).addClass("mobileActive");
        $(this).find(".c-link--5").addClass("mobileActive");
      },
    );

    $(document).on("mouseout blur", '[data-js="jsMobileHover"].mobileActive', function () {
        $(this).removeClass("mobileActive");
        $(this).find(".c-link--5").removeClass("mobileActive");
      },
    );
  }
});
